// Audit trail types for tracking project changes

export interface ProjectAuditLogEntry {
  id: string;
  project_id: string;
  changed_by: string;        // user email
  changed_at: string;        // ISO timestamp
  change_type: 'create' | 'update' | 'delete';
  field_name: string | null; // which field changed (null for create/delete)
  old_value: any;           // previous value (JSON)
  new_value: any;           // new value (JSON)
  change_summary: string;   // human-readable summary
}

// For displaying in the UI
export interface AuditLogDisplayEntry {
  id: string;
  timestamp: Date;
  changedBy: string;
  changeType: 'create' | 'update' | 'delete';
  fieldName: string | null;
  oldValue: any;
  newValue: any;
  summary: string;
}

// Field labels for human-readable display
export const FIELD_LABELS: Record<string, string> = {
  projectName: 'Project Name',
  status: 'Status',
  revenue: 'Monthly Retainer',
  profitMargin: 'Owner Margin',
  operationsOverheadPercentage: 'Operating Costs',
  operationsCompensationPerOwner: 'Operations Compensation',
  strategySponsor: 'Project Lead',
  operationsOwners: 'Operations Owners',
  tacticalSpecialists: 'Team Members',
  performanceKickers: 'Performance Bonuses',
};
